import React, { Component } from "react"
import { Link } from "gatsby"
import { css } from "emotion"

class PostImage extends Component {
  getImageUrl(node) {
    if (
      node &&
      node.featured_media &&
      node.featured_media.media_details &&
      node.featured_media.media_details.file
    ) {
      return "/wp-content/uploads/" + node.featured_media.media_details.file
    }
    return undefined
  }

  render() {
    let imageUrl = this.getImageUrl(this.props.node)
    let title = this.props.node.title
    let path = this.props.path
    /**
     * Conditional rendering. If imageUrl and path available other
     */
    if (imageUrl && path) {
      return (
        <>
          <div
            className={css`
              width: 100%;
              margin: 0 auto;
              img {
                max-width: 100%;
              }
            `}
          >
            <Link to={path}>
              <img alt={title} data-src={imageUrl} className="lazyLoad" />
            </Link>
          </div>
        </>
      )
    } else if (imageUrl) {
      return (
        <>
          <div
            className={css`
              width: 100%;
              margin: 0 auto;
              img {
                max-width: 100%;
              }
            `}
          >
            <img alt={title} data-src={imageUrl} className="lazyLoad" />
          </div>
        </>
      )
    } else {
      return ""
    }
  }
}

export default PostImage
